import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SlidersOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SlidersOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
          <path d="M10.9 8a5 5 0 1 1 0-2h11.6v2H10.9ZM9 7c0-1.65-1.35-3-3-3S3 5.35 3 7s1.35 3 3 3 3-1.35 3-3ZM13.1 16a5 5 0 1 1 0 2H1.5v-2h11.6Zm1.9 1c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3-3 1.35-3 3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default SlidersOutlined;